export const Name = 'Betsol'
export const Description = 'Meme The World Better'
export const Icon = location.origin + '/static/images/logo.png'

export const ContactAddress = {
  Email: 'contact@openhub.network',
  Telegram: 'https://t.me/BetsolMemeOfficial',
  Twitter: 'https://x.com/Betsoldotmeme',
  Instagram: '@OpenHub',
  Tiktok: '@OpenHub',
  Gitbook: 'https://betsols-organization.gitbook.io/',
  DevDocs: 'https://www.npmjs.com/package/betsol-sdk'
}

export const DocsUrl = 'https://betsols-organization.gitbook.io/'

export const Copyright = '©BETSOL ' + new Date().getFullYear()

export const GitBookLink = {
  MegaAirdropEvent:
    'https://betsols-organization.gitbook.io/betsol.gitbook.io/token-overview',
  'Dual-platformMiningEvent':
    'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/dual-platform-mining-event',
  InflunenceMiningEvent:
    'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/influence-mining-event',
  LiquidityCoCreationEvent:
    'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/liquidity-co-creation-event',
  PrivacyPolicy:
    'https://betsols-organization.gitbook.io/betsol.gitbook.io/legal-and-policy/privacy-policy',
  TermsOfService:
    'https://betsols-organization.gitbook.io/betsol.gitbook.io/legal-and-policy/terms-of-use',
  Fee: 'https://betsols-organization.gitbook.io/betsol.gitbook.io/graduation',
  MiningPointForDualPlatformUsers:
    'https://betsols-organization.gitbook.io/betsol.gitbook.io/mining-incentive-overview',
  InfluenceMiningEvent:
    'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/influence-mining-event',
  ContactUs:
    'https://betsols-organization.gitbook.io/betsol.gitbook.io/contact-us'
}
